/* eslint-disable react/jsx-key */
import React from "react";
import { TD, TR } from "../../../../../../styled";

const Content = ({ data, prepareRow }) => {
  return data.map((row) => {
    prepareRow(row);
    return (
      <TR {...row.getRowProps()}>
        {row.cells.map((cell) => {
          return <TD {...cell.getCellProps()}>{cell.render("Cell")}</TD>;
        })}
      </TR>
    );
  });
};

export default Content;
